module.exports = __webpack_public_path__ + "static/media/linkhardwareMainImg.267917fe.png";